import { createElementBlock as e, openBlock as o, createElementVNode as t } from "vue";
import { _ as n } from "./main-CXHfK21v.js";
const r = {};
function c(l, d) {
  return o(), e("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.02426 3.42465C5.25858 3.19034 5.25858 2.81044 5.02426 2.57613C4.78995 2.34181 4.41005 2.34181 4.17574 2.57613L0.175736 6.57613C-0.0585786 6.81044 -0.0585786 7.19034 0.175736 7.42465L4.17574 11.4247C4.41005 11.659 4.78995 11.659 5.02426 11.4247C5.25858 11.1903 5.25858 10.8104 5.02426 10.5761L1.44853 7.00039L5.02426 3.42465ZM9.82426 2.57613C9.58995 2.34181 9.21005 2.34181 8.97574 2.57613C8.74142 2.81044 8.74142 3.19034 8.97574 3.42465L12.5515 7.00039L8.97574 10.5761C8.74142 10.8104 8.74142 11.1903 8.97574 11.4247C9.21005 11.659 9.58995 11.659 9.82426 11.4247L13.8243 7.42465C14.0586 7.19034 14.0586 6.81044 13.8243 6.57613L9.82426 2.57613Z",
      fill: "white"
    })
  ]);
}
const s = /* @__PURE__ */ n(r, [["render", c]]);
export {
  s as default
};
